import React from "react";
import { Button, message, Modal } from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import { NHModal } from '../common/NHModal';
import EditForm from './EditForm.js';
import css from './index.css';
import { hasAuth } from '../../utils/NHCore';


const confirm = Modal.confirm;

const baseUrlPath = "/wbdStudentMng"; //基础路径

/**
 * 未报到学生管理列表
 * @author Xiafanglin
 * @date 2018-03-12 02:44:45
 * Version: 1.0
 */
class wbdStudent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            isAdd: true,
        };
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        // let rowKeys = this.refs.nhTable.state.selectedRowKeys;
        let rows = this.refs.nhTable.state.selectedRows;
        if (rows && rows.length == 1) {
            if (rows.WBDPKID) {
                this.setState({ isAdd: false });
            }
            this.setState({
                formInitData: rows
            }, () => { this.refs.nhAddModal.show() });
        } else {
            this.refs.nhAddModal.show()
            // message.warning('请选择一条需要维护的数据。');
        }

    }

    update = (recode) => {
        //该字段判断未报到表是否有数据 0没有1有
        let haswbc = recode['HASWBD'] == 0 ? true : false;
        this.setState({
            isAdd: haswbc,
            formInitData: recode
        }, () => { this.refs.nhAddModal.show() });
    }
    //新增面板保存方法
    handleSaveAdd = (stopLoading) => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }
            if (this.state.isAdd) {
                NHFetch(baseUrlPath + '/insert', 'POST', formData)
                    .then(res => {
                        if (res) {
                            message.success("操作成功！");
                            this.refs.nhAddModal.close();
                            this.refs.nhTable.filterTableData();
                        }
                        stopLoading();
                    }).catch(err => stopLoading());
            } else {
                NHFetch(baseUrlPath + '/update', 'POST', formData)
                    .then(res => {
                        if (res) {
                            message.success("操作成功！");
                            this.refs.nhAddModal.close();
                            this.refs.nhTable.filterTableData();
                            this.setState({ isAdd: true });
                        }
                        stopLoading();
                    }).catch(err => stopLoading());
            }

        });
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('未报到学生信息');
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '年度',
                width: '70px',
                dataIndex: 'ND',
                searchType:"select"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '70px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '50px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '校区',
                width: '100px',
                dataIndex: 'XQMC',
                searchType:"select"
            }, {
                title: '院系',
                width: '100px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '100px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '100px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '手机号',
                width: '100px',
                dataIndex: 'SJHM',
                searchType:"input"
            },{
                title: '未报到原因',
                width: '80px',
                dataIndex: 'WBDYY',
                searchType:"input"
            }
        ];
        //行内操作
        const action = [
            { title: '原因维护', onClick: this.update, auth: 'zhxg_yxgl_jcsj_wbdxsgl:reason' },
        ];
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.XSID}
                        sign={"zhxg_yxxt_wbdStudent_queryPage"}
                        columns={columns}
                        action={action}
                        rangeFilter={true}>

                        {hasAuth("zhxg_yxgl_jcsj_wbdxsgl:reason") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                    </NHTable>
                </div>
                <NHModal ref="nhAddModal"
                    title="原因维护"
                    onOk={this.handleSaveAdd}
                >
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData} />
                </NHModal>
            </div>
        );
    }
}
export default wbdStudent;



// WEBPACK FOOTER //
// ./components/wbdStudentMng/wbdStudent.js